import Vue from 'vue'
import VueRouter from 'vue-router'
import { setPageTitle } from '@/utils/seo'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/experts',
    name: 'ExpertTeam',
    component: () => import('@/views/ExpertTeam.vue'),
    meta: { title: '专家团队' }
  },
  {
    path: '/experts/:id',
    name: 'ExpertDetail',
    component: () => import('@/views/ExpertDetail.vue'),
    meta: { title: '专家详情' }
  },
  {
    path: '/recycling',
    name: 'Recycling',
    component: () => import('@/views/Recycling.vue'),
    meta: { title: '仪器回收' }
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: () => import('@/views/Cooperation.vue'),
    meta: { title: '校企合作' }
  },
  {
    path: '/cooperation/:id',
    name: 'CooperationDetail',
    component: () => import('@/views/CooperationDetail.vue'),
    meta: { title: '项目详情' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'ExpertDetail' && to.name !== 'CooperationDetail') {
    if (to.path === '/') {
      setPageTitle()
    } else {
      setPageTitle(to.meta.title)
    }
  }
  next()
})

export default router
